import CopyToClipboard from 'react-copy-to-clipboard'
import { toastHandler } from '../utils/Toast'

type Props = {
    content: string
    trigger: React.ReactNode
}

const CopytoClipboard = ({ trigger, content }: Props) => {
    return (
        <CopyToClipboard
            options={{
                debug: true,
            }}
            text={content}
            onCopy={() => toastHandler({ message: 'Copied to clipboard' })}
        >
            {trigger}
        </CopyToClipboard>
    )
}

export default CopytoClipboard
